import { render } from "./AddPieceModal.vue?vue&type=template&id=cc59e084&ts=true"
import script from "./AddPieceModal.vue?vue&type=script&lang=ts"
export * from "./AddPieceModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__